//--------------------------------------------------------------------------------------------------
//# Imports

import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';


//AppStart
const NavbarRouter = () => {
  const location = useLocation();
  const pathname = location['pathname'];

  // 0. AdminPage contains AdminNavbar
  if (pathname.includes('admin')) {
    return null;
  
  // 1. Landing Page shows default Navbar
  } else if (pathname === '/') {
    return <Navbar />;
  
  // x. Default shows default Navbar
  } else {
    return <Navbar />;
  };
};

export default NavbarRouter;